import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Loginservices } from '../login/login.services';

@Injectable({
  providedIn: 'root'
})
export class DefaultRouteGaurdGuard implements CanActivate {
  constructor(
    private loginService: Loginservices,
    private router: Router
  ) {}

  canActivate(): boolean {
    const userData = this.loginService.getLoggeduser();

    if (userData?.defaultpagemircroservice) {
      
      window.location.href = location.origin +userData.defaultpagemircroservice+"#/"
      // this.router.navigateByUrl(userData.defaultpagemircroservice);
      return false; // stop current navigation
    }

    return true;
  }
  
}
